import type { RawAxiosRequestHeaders } from "axios";
import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface Media {
  id: 1;
  title?: string;
  description?: string;
  url: string;
  alt?: string;
  caption?: string;
  created_at: string;
  updated_at: string;
  type: string;
  ext: string;
}
export interface MediaCreate {
  title?: string;
  description?: string;
  alt?: string;
  caption?: string;
  file: FileList;
}

export class MediaRepository extends BaseRepository<
  Media,
  undefined,
  MediaCreate
> {
  collection = "media";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  create(
    data: MediaCreate,
    header?: RawAxiosRequestHeaders
  ): Promise<ApiResponse<Media>> {
    const formData = new FormData();
    if (data.title) formData.append("title", data.title);
    if (data.description) formData.append("description", data.description);
    if (data.alt) formData.append("alt", data.alt);
    if (data.caption) formData.append("caption", data.caption);
    formData.append("file", data.file[0]);
    return super.create(formData, header);
  }

  get(id: number): Promise<ApiResponse<Media>> {
    return super.get(id);
  }

  public getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Media[]>> {
    return super.getMany(queryParams);
  }
}
